import { uniqueId } from '../helpers'
import axios from 'axios'
import moment from 'moment'
import store from '@/store/index'
import { apiErrorHandler } from '@/core/helpers/api.helpers'

/**
 * Get task data in the format to be passed as a call to /api/v1/task/tasks
 *
 * @param task
 */
export const getTaskAPIData = (task) => {
  const payload = {
    task_type_id: task.id,
    name: task.name ? task.name : `Custom Task ${uniqueId()}`,
    description: ''
  }

  if (!task.config.default) {
    payload.config = parseConfig(task.config)
  }

  return payload
}

/**
 *  Get task group data in the format to be passed as a call to /api/v1/task_groups
 *
 * @param formData
 * @param tasksIds
 */
export const getTaskGroupAPIData = (formData, tasksIds) => {
  const config = {}

  if ('options' in formData.user && !!formData.user.options) {
    formData.user.options.forEach(option => {
      config[option] = true
    })
  }

  const payload = {
    name: `Custom task group ${uniqueId()}`,
    description: '',
    task_ids: tasksIds,
    config: config
  }

  if (formData.tasks.length > 0) {
    if (formData.customTaskGroup.name) {
      payload['name'] = formData.customTaskGroup.name
    }

    if (formData.customTaskGroup.isPromoted) {
      payload['position'] = store.getters['tasks/lastTaskGroupPosition'] + 1
    }
  }

  return payload
}

/**
 * Parse the task configuration to the format expected by the API
 *
 * @param config
 */
export const parseConfig = (config) => {
  const apiConfig = {}

  Object.keys(config)
    .filter(field => (!!config[field] || +config[field] === 0) && field !== 'default' && config[field] !== 'random')
    .forEach(field => {
      apiConfig[field] = config[field]
    })

  return apiConfig
}

/**
 * Gets a list of previously created tasks from a particular task type
 *
 * @param taskTypeId
 * @returns {Promise<any>}
 */
export const fetchPreviousTasks = (taskTypeId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/v1/task/tasks?limit=-1&task_type_ids=${taskTypeId}`)
      .then((resp) => {
        resolve(resp.data.items)
      })
      .catch((resp) => {
        reject(resp)
      })
  })
}

/**
 * Update task type status [deleting/restoring]
 *
 * @param {Integer} id
 * @param {Boolean} isRestoring
 * @returns {Promise<any>}
 */
export const updateTaskTypeStatus = (id, isRestoring = true) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/v1/task/types/${id}`, { expires_at: isRestoring ? null : moment.utc().toISOString() })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        const handledError = apiErrorHandler(error)
        reject(handledError)
      })
  })
}
